var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',[_c('page-steps',{attrs:{"name":_vm.userLocale == 'es'
          ? _vm.citypass.title_es 
          : _vm.citypass.title_en}}),_c('user-profile-detail-info-page',{key:_vm.key,attrs:{"citypass":_vm.citypass}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }